import { cva } from 'class-variance-authority';

export const statusTotalsRootVariants = cva('bg-gray-700 py-2 pr-4 pl-6');

export const statusTotalsTextVariants = cva(
  'text-[12px] font-semibold not-italic leading-normal text-white'
);
